import { type FC, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth-store.js';

/**
 * Route guards (UX only). The server is authoritative: every platform API call
 * re-derives SUPER_ADMIN from the database, and every agency API refuses
 * platform sessions, so editing localStorage gains nothing.
 */

/** Agency area: signed-in agency users only; platform staff go to /platform. */
export const AgencyGate: FC<{ children: ReactNode }> = ({ children }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const platformRole = useAuthStore((s) => s.user?.platformRole ?? null);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (platformRole === 'SUPER_ADMIN') return <Navigate to="/platform/dashboard" replace />;
  return <>{children}</>;
};

/** Platform area: SUPER_ADMIN only; anyone else is sent back to their agency. */
export const PlatformGate: FC<{ children: ReactNode }> = ({ children }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const platformRole = useAuthStore((s) => s.user?.platformRole ?? null);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (platformRole !== 'SUPER_ADMIN') return <Navigate to="/" replace />;
  return <>{children}</>;
};
